import { dynamicSort } from '../utils/dynamicSort';
import { guid1 } from '../utils/guid';

let dataCache;

const nameSort = dynamicSort('name');

const getUsers = () =>
  ((dataCache && dataCache.user) || [])
    .filter(x => x.isActive || !x.hidden)
    .map(u => ({
      id: u.userID,
      name: `${u.firstName} ${u.lastName}`,
      isActive: u.isActive,
      email: u.email,
      languageCode: u.languageCode,
      hidden: u.hidden,
    }))
    .sort(nameSort);
const getAllUsers = () =>
  ((dataCache && dataCache.user) || [])
    .map(u => ({
      id: u.userID,
      name: `${u.firstName} ${u.lastName}`,
      isActive: u.isActive,
      email: u.email,
      languageCode: u.languageCode,
      hidden: u.hidden,
    }))
    .sort(nameSort);
const getSystemUser = () => dataCache?.systemUser;

const getUser = userId => {
  if (!userId || typeof userId !== 'string' || !dataCache || !dataCache.userObject) return null;
  if (userId === guid1) return dataCache.systemUser;
  /* Faster lookup than getAllUsers().find */
  const user = dataCache.userObject[userId];
  return user || null;
};
const getUserName = userId => {
  if (userId === guid1) return dataCache?.systemUser.name;
  const user = getUser(userId);
  if (!user) return null;
  return `${user.firstName} ${user.lastName}`;
};

const getUserLanguage = userId => {
  const user = getUser(userId);
  if (!user) return null;
  return user.languageCode;
};
const getDefaultCompanyForUser = (userId = null) => {
  if (!dataCache) return null;
  const employee = userId ? dataCache.user.find(x => x.userID === userId) : dataCache.employee;
  const companyId = employee?.companyId;
  const company = companyId
    ? dataCache.company.find(x => x.id === companyId)
    : dataCache.defaultcompany;
  return company;
};
export default {
  getDataCache: () => dataCache,
  setDataCache(cache) {
    dataCache = cache;
  },
  updateUser: (userId, updatedFields) => {
    if (dataCache && dataCache.userObject && dataCache.userObject[userId]) {
      Object.assign(dataCache.userObject[userId], updatedFields);
    }
  },
  hasConnectPlatform: (companyId, connectPlatform) => {
    const companyIdsToCheck = companyId ? [companyId] : Object.keys(dataCache.connectPlatforms);

    for (const companyIdToCheck of companyIdsToCheck) {
      if (
        dataCache.connectPlatforms[companyIdToCheck].filter(x => x === connectPlatform).length > 0
      ) {
        return true;
      }
    }

    return false;
  },
  hasUserConnectPlatform: connectPlatform => {
    if (
      !!dataCache.employee.configuredConnectPlatformsCommaSeparated &&
      dataCache.employee.configuredConnectPlatformsCommaSeparated
        .split(',')
        .filter(x => x === connectPlatform.toString()).length > 0
    ) {
      return true;
    }

    return false;
  },
  hasPortalConnectPlatform(companyId) {
    return this.hasConnectPlatform(companyId, 45);
  },
  shouldSeeSyncOverview(companyId) {
    const syncSupportedPlatforms = [
      45, // HIX
      49, // IonBiz
      50, // VisionPlanner
    ];

    return syncSupportedPlatforms.some(platform => this.hasConnectPlatform(companyId, platform));
  },
  getCompanySettings: companyId => {
    if (!dataCache) return {};
    const companyLookup = dataCache.companyObject && dataCache.companyObject[companyId]; // Use lookup object first (it's faster than a find)
    if (companyLookup) {
      return companyLookup;
    }
    if (!dataCache.company) return {};
    const company = dataCache.company && dataCache.company.find(x => x.id === companyId);
    return company;
  },
  getDefaultCompany: () => dataCache.defaultcompany,

  assignmentsEnabled: () => !!dataCache && dataCache.assignmentsEnabled,
  timeTablesEnabled: () => !!dataCache && dataCache.employeeTimeTables,
  getUsers,
  getUser,
  getAllUsers,
  getUserName,
  getSystemUser,
  isBelgianTenantConfiguration: () =>
    !dataCache
      ? true // fallback to true if datacache not ready yet
      : dataCache.tenantConfiguration === 0 || dataCache.tenantConfiguration === 1,
  getTenantConfiguration: () => !!dataCache && dataCache.tenantConfiguration,
  getUserLanguage,
  getDefaultCompanyForUser,
  getAbsenceRelationIdForUser: (userId = null) =>
    getDefaultCompanyForUser(userId)?.absenceRelationId,
};
